import { Point } from 'geojson';

class Anchor
{
    readonly id: string;
    readonly expiration: Date;
    readonly type: string | null;
    readonly geolocation: Point;
    readonly dimension: string;
    readonly location: string;
    readonly device: string | null;
    readonly envs: any;
    file: any;
    google: any;

    constructor(data: any) {
        if (!data) {
            throw "Null data for Anchor";
        }
        this.id = data.id;
        this.expiration = data.expiration;
        this.type = data.type ? data.type : null;
        this.geolocation = data.geolocation;
        this.dimension = data.dimension;
        this.location = data.location;
        this.device = data.device ? data.device : null;
        this.envs = data.envs;
        this.file = data.file;
        this.google = data.google;
    }

}

export default Anchor;
